import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './TopRatedMovies.css'; // Your custom styles (if any)
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap styles

const TopRatedMovies = () => {
  const [topRatedMovies, setTopRatedMovies] = useState([]);

  useEffect(() => {
    const topRatedMovieIds = [
      // Marvel movies
      284054,   // Black Panther (2018)
      315635,   // Spider-Man: Homecoming (2017)
      299536,   // Avengers: Infinity War (2018)
      246655,   // Guardians of the Galaxy (2014)
      263115,   // Logan (2017)
      118340,   // Guardians of the Galaxy Vol. 2 (2017)
      100402,   // Captain America: The Winter Soldier (2014)
      1726,     // Iron Man (2008)
      299534,   // Avengers: Endgame (2019)
      284053,   // Thor: Ragnarok (2017)
      // DC movies
      49026,    // The Dark Knight (2008)
      297762,   // Wonder Woman (2017)
      297802,   // Aquaman (2018)
      287947,   // Shazam! (2019)
      49521,    // Man of Steel (2013)
      209112,   // Batman v Superman: Dawn of Justice (2016)
      141052,   // Justice League (2017)
      297761,   // Suicide Squad (2016)
      414906,   // The Batman (2022)
      475557,   // Joker (2019)
      // Movies with adult themes
      216015,   // Fifty Shades of Grey (2015)
      337339,   // Fast and Furious
      337401,   // Mulan
      11010,    // Postman
      245891,   // John Wick
      245842,   // Legend of the Seeker (TV Series 2008–2010)
      354912,   // Coco
      635302,   // Avatar: The Last Air bender (TV Series 2005–2008)
      19995,    // Avatar (2009)
      141052,   // Avatar: The Way of Water (2022)
    ];

    const fetchMovies = async () => {
      const apiKey = process.env.REACT_APP_TMDB_API_KEY;
      try {
        const moviePromises = topRatedMovieIds.map(async (id) => {
          const response = await fetch(
            `https://api.themoviedb.org/3/movie/${id}?api_key=${apiKey}&language=en-US`
          );
          const data = await response.json();
          return data;
        });

        // Wait for all movie promises to resolve
        const moviesData = await Promise.all(moviePromises);
        
        // Shuffle the array of movies and pick the first 12
        const shuffledMovies = shuffleArray(moviesData);
        setTopRatedMovies(shuffledMovies.slice(0, 12));
      } catch (error) {
        console.error('Error fetching top rated movies:', error);
      }
    };

    fetchMovies();
  }, []);

  // Function to shuffle array (Fisher-Yates shuffle algorithm)
  const shuffleArray = (array) => {
    let currentIndex = array.length, randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]
      ];
    }

    return array;
  };

  return (
    <div className="containers top-rated-container">
      <h2 className="top-rated-heading">Top Rated Movies</h2>
      
      <div className="row">
        {topRatedMovies.map((movie) => (
          <div key={movie.id} className="col-lg-2 col-md-3 col-sm-4 col-6 mb-4">
            <Link to={`/movies/${movie.id}`} className="movie-link">
              <img
                src={`https://image.tmdb.org/t/p/w300${movie.poster_path}`}
                alt={movie.title}
                className='movie-poster img-fluid'
              />
              <div className="movie-title linking">{movie.title}</div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopRatedMovies;
